




























import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { store } from "@/store/store";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { ApiResponse } from "@/types/types";

export default Vue.extend({
  name: "DeviceDeleteModal",
  components: { Modal, Paragraph },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    onAction: {
      type: Function,
      default: () => undefined
    },
    device: {
      type: Object
    }
  },
  data: () => {
    return {
      title: "Supprimer l'appareil",
      loading: false
    };
  },
  methods: {
    async onDelete(_id: string): Promise<boolean> {
      const response = await store.dispatch(DeviceActionsTypes.ARCHIVE_DEVICE, _id);
      return response === ApiResponse.SUCCESS ? true : false;
    },
    async onClickHandler(): Promise<void> {
      const u = { ...this.device };
      this.loading = true;
      if (await this.onDelete(this.device.material_name)) {
        this.loading = false;
        this.onAction({
          type: "SUCCESS",
          title: "Suppression",
          content: `L'appareil' ${u.material_name} a bien été supprimé.`
        });
        this.onClose();
      } else {
        this.loading = false;
        this.onAction({
          type: "ERROR",
          title: "Suppression",
          content: `Une erreur s'est produite lors de la suppression`
        });
      }
    }
  }
});
